/**
 * Generated from LightsOutElmoKitchenLayout.fla
 */
export function LightsOutElmoKitchenLayout(this: ILightsOutElmoKitchenLayout) {
	const bg = this.bg;
	LightsOutElmoKitchenLayout_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	LightsOutElmoKitchenLayout_homeButton.call(this.homeButton);
	homeButton.x = 428;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const pots = this.pots;
	LightsOutElmoKitchenLayout_pots.call(this.pots);
	pots.x = 589.75;
	pots.y = 320;
	pots.width = 85.00;
	pots.height = 108.55;
	if (pots.onLayout) pots.onLayout();
	const cabinetLighting = this.cabinetLighting;
	LightsOutElmoKitchenLayout_cabinetLighting.call(this.cabinetLighting);
	cabinetLighting.x = 772.25;
	cabinetLighting.y = 269.5;
	cabinetLighting.width = 470.50;
	cabinetLighting.height = 13.00;
	if (cabinetLighting.onLayout) cabinetLighting.onLayout();
	const cabinetLightSwitch = this.cabinetLightSwitch;
	LightsOutElmoKitchenLayout_cabinetLightSwitch.call(this.cabinetLightSwitch);
	cabinetLightSwitch.x = 911.45;
	cabinetLightSwitch.y = 309;
	cabinetLightSwitch.width = 29.00;
	cabinetLightSwitch.height = 50.00;
	if (cabinetLightSwitch.onLayout) cabinetLightSwitch.onLayout();
	const fan = this.fan;
	LightsOutElmoKitchenLayout_fan.call(this.fan);
	fan.x = 769.75;
	fan.y = 73;
	fan.width = 261.50;
	fan.height = 136.00;
	if (fan.onLayout) fan.onLayout();
	const cookieJar = this.cookieJar;
	LightsOutElmoKitchenLayout_cookieJar.call(this.cookieJar);
	cookieJar.x = 372.5;
	cookieJar.y = 364;
	cookieJar.width = 57.00;
	cookieJar.height = 62.00;
	if (cookieJar.onLayout) cookieJar.onLayout();
	const curtains = this.curtains;
	LightsOutElmoKitchenLayout_curtains.call(this.curtains);
	curtains.x = 771.25;
	curtains.y = 251;
	curtains.width = 165.00;
	curtains.height = 92.50;
	if (curtains.onLayout) curtains.onLayout();
	const fanSwitch = this.fanSwitch;
	LightsOutElmoKitchenLayout_fanSwitch.call(this.fanSwitch);
	fanSwitch.x = 968.25;
	fanSwitch.y = 308.5;
	fanSwitch.width = 44.50;
	fanSwitch.height = 55.05;
	if (fanSwitch.onLayout) fanSwitch.onLayout();
	const faucet = this.faucet;
	LightsOutElmoKitchenLayout_faucet.call(this.faucet);
	faucet.x = 771.75;
	faucet.y = 310;
	faucet.width = 104.50;
	faucet.height = 74.00;
	if (faucet.onLayout) faucet.onLayout();
	const fridgeBottom = this.fridgeBottom;
	LightsOutElmoKitchenLayout_fridgeBottom.call(this.fridgeBottom);
	fridgeBottom.x = 1194;
	fridgeBottom.y = 421;
	fridgeBottom.width = 204.50;
	fridgeBottom.height = 196.00;
	if (fridgeBottom.onLayout) fridgeBottom.onLayout();
	const fridgeTop = this.fridgeTop;
	LightsOutElmoKitchenLayout_fridgeTop.call(this.fridgeTop);
	fridgeTop.x = 1194;
	fridgeTop.y = 437;
	fridgeTop.width = 204.50;
	fridgeTop.height = 219.55;
	if (fridgeTop.onLayout) fridgeTop.onLayout();
	const wallLight = this.wallLight;
	LightsOutElmoKitchenLayout_wallLight.call(this.wallLight);
	wallLight.x = 428.5;
	wallLight.y = 291.5;
	wallLight.width = 57.00;
	wallLight.height = 87.00;
	if (wallLight.onLayout) wallLight.onLayout();
	const wallLightSwitch = this.wallLightSwitch;
	LightsOutElmoKitchenLayout_wallLightSwitch.call(this.wallLightSwitch);
	wallLightSwitch.x = 503.25;
	wallLightSwitch.y = 297.5;
	wallLightSwitch.width = 44.50;
	wallLightSwitch.height = 55.05;
	if (wallLightSwitch.onLayout) wallLightSwitch.onLayout();
	const walllightGlow = this.walllightGlow;
	LightsOutElmoKitchenLayout_walllightGlow.call(this.walllightGlow);
	walllightGlow.x = 428.5;
	walllightGlow.y = 273.25;
	walllightGlow.width = 37.00;
	walllightGlow.height = 46.50;
	if (walllightGlow.onLayout) walllightGlow.onLayout();
	const cabinetlightingGlow = this.cabinetlightingGlow;
	LightsOutElmoKitchenLayout_cabinetlightingGlow.call(this.cabinetlightingGlow);
	cabinetlightingGlow.x = 771;
	cabinetlightingGlow.y = 270.2;
	cabinetlightingGlow.width = 474.50;
	cabinetlightingGlow.height = 30.50;
	if (cabinetlightingGlow.onLayout) cabinetlightingGlow.onLayout();
	const fanGlow = this.fanGlow;
	LightsOutElmoKitchenLayout_fanGlow.call(this.fanGlow);
	fanGlow.x = 769.65;
	fanGlow.y = 126.5;
	fanGlow.width = 127.00;
	fanGlow.height = 41.00;
	if (fanGlow.onLayout) fanGlow.onLayout();
	const elmo = this.elmo;
	LightsOutElmoKitchenLayout_elmo.call(this.elmo);
	elmo.x = 960.5;
	elmo.y = 726;
	elmo.width = 198.90;
	elmo.height = 288.00;
	if (elmo.onLayout) elmo.onLayout();
	return this;
}
function LightsOutElmoKitchenLayout_bg(this: ILightsOutElmoKitchenLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightsout-background.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_homeButton(this: ILightsOutElmoKitchenLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_pots(this: ILightsOutElmoKitchenLayout_pots) {
	if (this.setLayoutTexture) this.setLayoutTexture("pots.png", 0.479, 0.497);
	return this;
}
function LightsOutElmoKitchenLayout_cabinetLighting(this: ILightsOutElmoKitchenLayout_cabinetLighting) {
	if (this.setLayoutTexture) this.setLayoutTexture("cabinetlighting.png", 0.502, 0.615);
	return this;
}
function LightsOutElmoKitchenLayout_cabinetLightSwitch(this: ILightsOutElmoKitchenLayout_cabinetLightSwitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("cabinetLightSwitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_fan(this: ILightsOutElmoKitchenLayout_fan) {
	if (this.setLayoutTexture) this.setLayoutTexture("fan.png", 0.501, 0.537);
	return this;
}
function LightsOutElmoKitchenLayout_cookieJar(this: ILightsOutElmoKitchenLayout_cookieJar) {
	if (this.setLayoutTexture) this.setLayoutTexture("cookiejar.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_curtains(this: ILightsOutElmoKitchenLayout_curtains) {
	if (this.setLayoutTexture) this.setLayoutTexture("curtains.png", 0.492, 0.508);
	return this;
}
function LightsOutElmoKitchenLayout_fanSwitch(this: ILightsOutElmoKitchenLayout_fanSwitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("FanSwitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_faucet(this: ILightsOutElmoKitchenLayout_faucet) {
	if (this.setLayoutTexture) this.setLayoutTexture("faucet.png", 0.498, 0.000);
	return this;
}
function LightsOutElmoKitchenLayout_fridgeBottom(this: ILightsOutElmoKitchenLayout_fridgeBottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("fridgebottom.png", 0.499, 0.000);
	return this;
}
function LightsOutElmoKitchenLayout_fridgeTop(this: ILightsOutElmoKitchenLayout_fridgeTop) {
	if (this.setLayoutTexture) this.setLayoutTexture("fridgetop.png", 0.499, 1.002);
	return this;
}
function LightsOutElmoKitchenLayout_wallLight(this: ILightsOutElmoKitchenLayout_wallLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("walllight.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_wallLightSwitch(this: ILightsOutElmoKitchenLayout_wallLightSwitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("walllightswitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_walllightGlow(this: ILightsOutElmoKitchenLayout_walllightGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("walllight-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_cabinetlightingGlow(this: ILightsOutElmoKitchenLayout_cabinetlightingGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("cabinetlighting-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_fanGlow(this: ILightsOutElmoKitchenLayout_fanGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("fan-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoKitchenLayout_elmo(this: ILightsOutElmoKitchenLayout_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("Elmo.png", 0.503, 1.000);
	return this;
}
interface ILightsOutElmoKitchenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILightsOutElmoKitchenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILightsOutElmoKitchenLayoutSprite extends ILightsOutElmoKitchenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILightsOutElmoKitchenLayoutText extends ILightsOutElmoKitchenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILightsOutElmoKitchenLayoutPolygon extends Array<number> {
}
interface ILightsOutElmoKitchenLayout {
	readonly bg: ILightsOutElmoKitchenLayout_bg;
	readonly homeButton: ILightsOutElmoKitchenLayout_homeButton;
	readonly pots: ILightsOutElmoKitchenLayout_pots;
	readonly cabinetLighting: ILightsOutElmoKitchenLayout_cabinetLighting;
	readonly cabinetLightSwitch: ILightsOutElmoKitchenLayout_cabinetLightSwitch;
	readonly fan: ILightsOutElmoKitchenLayout_fan;
	readonly cookieJar: ILightsOutElmoKitchenLayout_cookieJar;
	readonly curtains: ILightsOutElmoKitchenLayout_curtains;
	readonly fanSwitch: ILightsOutElmoKitchenLayout_fanSwitch;
	readonly faucet: ILightsOutElmoKitchenLayout_faucet;
	readonly fridgeBottom: ILightsOutElmoKitchenLayout_fridgeBottom;
	readonly fridgeTop: ILightsOutElmoKitchenLayout_fridgeTop;
	readonly wallLight: ILightsOutElmoKitchenLayout_wallLight;
	readonly wallLightSwitch: ILightsOutElmoKitchenLayout_wallLightSwitch;
	readonly walllightGlow: ILightsOutElmoKitchenLayout_walllightGlow;
	readonly cabinetlightingGlow: ILightsOutElmoKitchenLayout_cabinetlightingGlow;
	readonly fanGlow: ILightsOutElmoKitchenLayout_fanGlow;
	readonly elmo: ILightsOutElmoKitchenLayout_elmo;
}
interface ILightsOutElmoKitchenLayout_bg extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_homeButton extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_pots extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_cabinetLighting extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_cabinetLightSwitch extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_fan extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_cookieJar extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_curtains extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_fanSwitch extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_faucet extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_fridgeBottom extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_fridgeTop extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_wallLight extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_wallLightSwitch extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_walllightGlow extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_cabinetlightingGlow extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_fanGlow extends ILightsOutElmoKitchenLayoutSprite {
}
interface ILightsOutElmoKitchenLayout_elmo extends ILightsOutElmoKitchenLayoutSprite {
}
